module.exports = __webpack_public_path__ + "static/eligible-a17cc8e607c20d441b47e9d893e55ce0.png";